/* src/app/header/header.component.css */
.siteLogo > span {
  font-size: 1.75em;
}
.topNav > li {
  float: left;
  margin-left: 1em;
}
.topNav2 {
  list-style: none;
  padding: 0;
  text-align: right;
  clear: right;
  float: right;
  margin-top: 0.25em;
}
.topNav2 > li {
  float: left;
  margin-left: 1em;
}
.topNav2 > li > a {
  border-radius: 4px;
  line-height: 2;
  padding: 0 .5em;
  transition: background .15s linear;
}
.topNav2 a {
  color: #001F3F;
  display: block;
  text-decoration: none;
}
.topNav2 a:hover,
.topNav2 a:focus {
  background: #353535;
  color: #fff;
}
/*# sourceMappingURL=header.component.css.map */
